import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Button,
  Dropdown,
  InputGroup,
  Form,
  Table,
} from "react-bootstrap";
import {
  FaPlus,
  FaCog,
  FaFilter,
  FaRedo,
  FaSearch,
  FaSort,
  FaToggleOff,
  FaToggleOn,
  FaEdit,
  FaTrashAlt,
} from "react-icons/fa";
import {
  getBookingList,
  updateBookingStatus,
  deleteBooking,
} from "../../../services/OrganisationServices/transportManagemetService.js";
import { getMethods } from "../../../services/utilityFunctions";
import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import AddBookingForm from "../../FormComponents/AddBookingForm";

import { useGlobalState } from "../../../services/hostelConst";

const TransportBookingTable = () => {
  const { _advanceFilterList, updateAdvanceFilterList } = useGlobalState();

  useEffect(() => {
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });
    return () => {};
  }, []);

  return (
    <>
      <MasterTable
        getTableData={getBookingList}
        tab1={"Transport"}
        tab2={"Booking"}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
        updateStatus={updateBookingStatus}
        AddForm={AddBookingForm}
        deleteRow={deleteBooking}
      />
    </>
  );
};

export default TransportBookingTable;
